// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiUpcomingMemeSubscriptionStatus {
    'subscribed': boolean;
    'eligibility': number;
    'count'?: number;
    'source'?: ApiUpcomingMemeSubscriptionStatusSourceEnum;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "subscribed",
            "baseName": "subscribed",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "eligibility",
            "baseName": "eligibility",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "count",
            "baseName": "count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "source",
            "baseName": "source",
            "type": "ApiUpcomingMemeSubscriptionStatusSourceEnum",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiUpcomingMemeSubscriptionStatus.attributeTypeMap;
    }

    public constructor() {
    }
}

export enum ApiUpcomingMemeSubscriptionStatusSourceEnum {
    Automatic = 'automatic',
    Manual = 'manual'
}

